import { numberToLocale } from '@forms/client/AddProductForm/utils';
import { PackagingPick } from '@features/supplyChain/types';

interface PackagingBreakdownProps {
  packaging?: PackagingPick[] | null;
  looseProducts?: number;
}

export function PackagingBreakdown({
  packaging,
  looseProducts = 0,
}: PackagingBreakdownProps) {
  const groups = (packaging ?? []).filter((group) => group.quantity > 0);

  if (groups.length === 0 && looseProducts <= 0) {
    return <span className='text-sm text-gray-400'>—</span>;
  }

  return (
    <div className='flex flex-col gap-0.5 text-sm text-gray-900'>
      {groups.map((group) => {
        const unitNoun = group.type || 'unit';
        return (
          <span key={group.packagingId || unitNoun}>
            {numberToLocale(group.quantity)} {unitNoun}
            {group.quantity === 1 ? '' : 's'}
            <span className='ml-1 text-xs text-gray-500'>
              ({numberToLocale(group.skusPerUnit * group.quantity)} units)
            </span>
          </span>
        );
      })}
      {looseProducts > 0 && (
        <span className='text-amber-700'>
          {numberToLocale(looseProducts)}
          <span className='ml-1 text-xs text-gray-500'>loose products</span>
        </span>
      )}
    </div>
  );
}
